/* OH ✦ HELLO — swipeable photos on collection product cards.
   Each card on a collection page carries a <template data-oh-cs> with photos 2–3.
   This turns the card's image link into a sideways-swipe strip with dots (bottom-left).
   - Phone: swipe with a finger (vertical page scrolling is unaffected).
   - Desktop: drag with the mouse, or click a dot.
   - A tap/click without dragging still opens the product page. */
(function () {
  if (window.__ohCardSwipe) return;
  window.__ohCardSwipe = true;

  function build(tpl) {
    if (tpl.dataset.ohCsDone) return;
    tpl.dataset.ohCsDone = '1';
    var figure = tpl.closest('.product-card__figure');
    if (!figure) return;
    var link = figure.querySelector('.product-card__media');
    if (!link) return;
    var primary = link.querySelector('.product-card__image--primary') || link.querySelector('img');
    if (!primary) return;

    var secondary = link.querySelector('.product-card__image--secondary');
    if (secondary) secondary.remove(); // hover photo is replaced by the swipe strip

    var track = document.createElement('div');
    track.className = 'oh-cs-track';
    var first = document.createElement('div');
    first.className = 'oh-cs-slide';
    primary.parentNode.insertBefore(track, primary);
    first.appendChild(primary);
    track.appendChild(first);

    var extra = tpl.content ? tpl.content.cloneNode(true) : null;
    if (extra) {
      Array.prototype.forEach.call(extra.querySelectorAll('img'), function (img) {
        var slide = document.createElement('div');
        slide.className = 'oh-cs-slide';
        slide.appendChild(img);
        track.appendChild(slide);
      });
    }

    var count = track.children.length;
    if (count < 2) return;

    var dots = document.createElement('div');
    dots.className = 'oh-cs-dots';
    for (var i = 0; i < count; i++) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'oh-cs-dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Photo ' + (i + 1) + ' of ' + count);
      dot.dataset.index = i;
      dots.appendChild(dot);
    }
    figure.appendChild(dots);

    function current() { return Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)); }
    function paint() {
      var n = current();
      Array.prototype.forEach.call(dots.children, function (d, idx) { d.classList.toggle('is-active', idx === n); });
    }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(paint); }, { passive: true });

    dots.addEventListener('click', function (e) {
      var d = e.target.closest('.oh-cs-dot');
      if (!d) return;
      e.preventDefault();
      e.stopPropagation();
      track.scrollTo({ left: Number(d.dataset.index) * track.clientWidth, behavior: 'smooth' });
    });

    // Mouse drag on desktop (touch uses native swiping)
    var startX = 0, startLeft = 0, dragging = false, moved = false;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      dragging = true; moved = false;
      startX = e.clientX; startLeft = track.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 5) { moved = true; track.classList.add('is-dragging'); }
      if (moved) track.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!dragging) return;
      dragging = false;
      if (moved) {
        track.classList.remove('is-dragging');
        var target = Math.round(track.scrollLeft / track.clientWidth);
        var dir = track.scrollLeft - startLeft;
        if (Math.abs(dir) > track.clientWidth * 0.15) target = dir > 0 ? Math.ceil(startLeft / track.clientWidth + 0.01) : Math.floor(startLeft / track.clientWidth - 0.01);
        target = Math.max(0, Math.min(count - 1, target));
        track.scrollTo({ left: target * track.clientWidth, behavior: 'smooth' });
      }
    });
    // A drag shouldn't count as a click on the product link
    link.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
    link.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  function scan(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('template[data-oh-cs]:not([data-oh-cs-done])'), build);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();

  // Filters, sorting and "load more" replace the product grid — set up the new cards too
  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) { scan(); break; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
